module.exports = __webpack_public_path__ + "static/img/TranslationStandards.775f0c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/TranslationStandards.png
// module id = 0PWh
// module chunks = 1